import type { NexusSignal } from "@otto-ec/global-resources/nexus";
import { toggle } from "@otto-ec/global-resources/toggle";

declare module "@otto-ec/nexus-registry/reco/cinemas" {
    interface RecoCinemasRaw {
        renderBounceLayerRecommendationsInternal: NexusSignal<any>,
        renderWishlistRecommendationsInternal: NexusSignal<any>,
        renderOrderOverviewRecommendationsInternal: NexusSignal<any>,
        renderPdpRecommendationsInternal: NexusSignal<any>,
    }
}

export async function setUpInternalInterfaces() {
    if (!import.meta.env.SSR) {
        const {
            renderBounceLayerRecommendations,
            renderPdpRecommendations,
            renderWishlistRecommendations,
            renderOrderOverviewRecommendations,
        } = await import("@otto-ec/nexus-registry/reco/cinemas");
        if(toggle.get("ftsix_enable_bouncelayer_nexus_ssr")) {
            renderBounceLayerRecommendations.assignFunction((payload: any) => {
                window.otto.reco.cinemas.renderBounceLayerRecommendationsInternal.emit(payload);
            });
        }
        if(toggle.get("ftsix_enable_wishlist_nexus_ssr")) {
            renderWishlistRecommendations.assignFunction((payload: any) => {
                window.otto.reco.cinemas.renderWishlistRecommendationsInternal.emit(payload);
            });
        }
        if(toggle.get("ftsix_enable_orderoverview_nexus_ssr")) {
            renderOrderOverviewRecommendations.assignFunction((payload: any) => {
                window.otto.reco.cinemas.renderOrderOverviewRecommendationsInternal.emit(payload);
            });
        }
        if(toggle.get("ftsix_enable_pdp_nexus_ssr")) {
            renderPdpRecommendations.assignFunction((payload: any) => {
                window.otto.reco.cinemas.renderPdpRecommendationsInternal.emit(payload);
            });
        }
    }
};

